module.exports = __webpack_public_path__ + "assets_1773307907123/img/logo.71acd534.png";